import { Filter } from '@type-declarations/filters';
import { Tag } from '@type-declarations/prepr';

export function tagToFilter(tags: Tag[]): Filter[] {
  return tags.map(tag => ({
    value: tag.slug,
    title: tag.title,
  }));
}
